module.exports = __webpack_public_path__ + "img/No_Sub-national_Data.13c42a9b.svg";